var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFocusedDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    rx: 10,
    fill: "#0F90FF",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 20C12 18.3431 13.3431 17 15 17H40C41.6569 17 43 18.3431 43 20V35C43 36.6569 41.6569 38 40 38H15C13.3431 38 12 36.6569 12 35V20Z",
    fill: "white",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7001 22.6001L36.7001 22.6001",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7001 26.8003L36.7001 26.8003",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4 32.4004L31.8 32.4004",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7 32.4004H35.3",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8073 27.3115C22.6177 27.3115 23.3949 26.9896 23.9679 26.4165C24.541 25.8435 24.8629 25.0663 24.8629 24.2559C24.8629 23.4454 24.541 22.6682 23.9679 22.0952C23.3949 21.5221 22.6177 21.2002 21.8073 21.2002C20.9969 21.2002 20.2196 21.5221 19.6466 22.0952C19.0735 22.6682 18.7516 23.4454 18.7516 24.2559C18.7516 25.0663 19.0735 25.8435 19.6466 26.4165C20.2196 26.9896 20.9969 27.3115 21.8073 27.3115ZM26.9 33.3518C26.899 33.1012 26.5051 31.6908 25.8145 31.0002C25.1504 30.3361 24.1387 29.6002 21.8073 29.6002C19.4748 29.6002 18.0786 30.3361 17.4145 31.0002C16.7239 31.6908 16.7165 33.1012 16.7145 33.3518H26.9Z",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12 5H8C6.34315 5 5 6.34315 5 8V13",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12 50H8C6.34315 50 5 48.6569 5 47V42",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5H47C48.6569 5 50 6.34315 50 8V13",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43 50H47C48.6569 50 50 48.6569 50 47V42",
    stroke: "#0F90FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocusedDocument);
export default __webpack_public_path__ + "static/media/focusedDocument.8985a91c715c22e4da2836bf0a2f4591.svg";
export { ForwardRef as ReactComponent };